import { helper } from '@ember/component/helper';
import ContactModel from 'donor-elf-web/models/contact';

// {{contact-has-custom-property-label contact customPropertyLabel}}
// returns boolean
export default helper(function contactHasCustomPropertyLabel(
  [contact, label] /*, hash*/,
) {
  return (
    (contact as ContactModel).customPropertiesByLabel[label as string] != null
  );
});
